.list > li {
  margin-top: 2rem;
}
